// extracted by mini-css-extract-plugin
export default {"inputSelectTextArea":"OnboardingCreateProfileTextarea_inputSelectTextArea__1MWec","errorMessage":"OnboardingCreateProfileTextarea_errorMessage__Ln16S"};